import { LANGS } from "@/lib/i18n";
import { useLang } from "@/context/LanguageContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/**
 * variant="ss" — cream/gold theme for /shop
 * variant="hq" — dark admin theme (default for the admin dashboard)
 */
export function LanguageSwitcher({ compact = false, variant = "hq" }) {
  const { lang, setLang } = useLang();
  const current = LANGS.find((l) => l.code === lang) || LANGS[1];
  const ss = variant === "ss";
  const btnCls = ss ? "ss-btn ss-btn-ghost text-xs" : "hq-btn hq-btn-ghost";
  const menuCls = ss
    ? "bg-white border border-[color:var(--ss-border-strong)] text-[color:var(--ss-ink)] min-w-[160px]"
    : "bg-[#0d0d0d] border border-white/10 text-white min-w-[160px]";
  const labelMuted = ss ? "text-[color:var(--ss-ink-muted)]" : "text-white/60";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="language-switcher" className={btnCls} aria-label="Language">
          <Globe size={14} />
          <span className="font-mono text-xs uppercase">{current.code}</span>
          {!compact && <span className={`hidden md:inline text-xs ${labelMuted}`}>{current.label}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className={menuCls}>
        {LANGS.map((l) => {
          const active = l.code === lang;
          const itemCls = ss
            ? `cursor-pointer text-sm ${active ? "text-[color:var(--ss-gold)]" : "text-[color:var(--ss-ink)]"} focus:bg-[color:var(--ss-bg-soft)]`
            : `cursor-pointer text-sm ${active ? "text-[color:var(--hq-cyan)]" : "text-white/80"} focus:bg-white/5 focus:text-white`;
          return (
            <DropdownMenuItem
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => setLang(l.code)}
              className={itemCls}
            >
              <span className={`font-mono text-xs mr-3 uppercase ${labelMuted}`}>{l.code}</span>
              {l.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
